<template>
    <v-container fluid>
        <v-layout class="align-center">
            <v-flex>
                <h2 class="headline">Kunder</h2>
            </v-flex>
            <v-spacer/>
            <v-flex shrink>
                <edit-customer-dialog @save="redirectToCustomer"/>
            </v-flex>
        </v-layout>

        <div class="filter-container">
            <affix relative-element-selector="#customers" :offset="{top: 150, bottom: 200}">
                <customer-filter @filter="loadData($event)" class="mb-3"/>
            </affix>
        </div>

        <v-data-table id="customers" :headers="headers" :items="customers" class="elevation-1"
                      :loading="loading"
                      :items-per-page="100"
                      :options.sync="options"
                      :server-items-length="total"
                      :footer-props="footerProps"
                      :expanded.sync="expanded"
                      :single-expand="true"
                      :no-data-text="loading ? 'Laster...' : 'Ingen data funnet.'"
                      no-results-text="Ingen resultater funnet.">
            <template v-slot:item="{ item, isExpanded, expand }">
                <tr @click="expand" :class="getRowClasses(item, isExpanded)">
                    <td>
                        <span v-if="item.customer_number">#{{ item.customer_number }}</span>
                        <em class="grey--text" v-else>Mangler</em>
                    </td>
                    <td>
                        {{ item.name }}
                    </td>
                    <td class="text-center">
                        <customer-type :value="item"/>
                        <strong v-if="item.deleted_at" class="red--text pl-3">Arkivert</strong>
                    </td>
                    <td>
                        <a :href="`tel:${item.phone}`" class="contact-link" v-if="item.phone">
                            <v-icon small>phone</v-icon>
                            {{ item.phone }}
                        </a>
                        <em class="grey--text" v-else>Mangler</em>
                    </td>
                    <td>
                        <a :href="`mailto:${item.email}`" class="contact-link" v-if="item.email">
                            <v-icon small>mail</v-icon>
                            <span class="hidden-md-and-down">{{ item.email }}</span>
                        </a>
                        <em class="grey--text" v-else>Mangler</em>
                    </td>
                    <td class="text-center">
                        <strong v-if="item.cars_count">
                            {{ item.cars_count }} stk.
                        </strong>
                        <em class="grey--text" v-else>Ingen</em>
                    </td>
                    <td>
                        {{ item.address }}<br>
                        <small>{{ item.zip_code }} {{ item.city }}</small>
                    </td>
                    <td class="text-center" style="width: 1px;">
                        <v-btn text color="primary" :to="{name: 'CustomerShow', params: {id: item.id}}">
                            <v-icon left>person</v-icon>
                            Vis kunde
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:expanded-item="{ item, headers }">
                <td :colspan="headers.length">
                    <v-card text color="blue-grey">
                        <v-card-text>
                            <car-table :customer-id="item.id" :invoice-year="invoiceYear" ignore-filter :show-deleted="!!item.deleted_at"/>
                        </v-card-text>
                    </v-card>
                </td>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
    import CustomerType from '../helpers/CustomerType';
    import EditCustomerDialog from '../helpers/EditCustomerDialog';
    import CustomerFilter from '../helpers/filter/CustomerFilter';
    import CarTable from '../helpers/CarTable';
    import {tableOptionsFromRoute, updateRouteFromOptions} from "../../helpers";

    export default {
        name: 'CustomerIndex',
        components: {
            EditCustomerDialog,
            CustomerType,
            CustomerFilter,
            CarTable
        },

        data() {
            return {
                loading: false,
                customers: [],
                meta: null,
                expanded: [],
                invoiceYear: null
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData(filter = {}) {
                this.loading = true;
                let data = {
                    params: {
                        ...this.$route.query,
                        ...filter
                    }
                };

                this.invoiceYear = data.params.invoice_year

                this.$http.get('customers', data).then(response => {
                    this.customers = response.data.data;
                    this.meta = response.data.meta;
                }).finally(() => this.loading = false);
            },

            redirectToCustomer(customer) {
                this.$router.push({name: 'CustomerShow', params: {id: customer.id}});
            },

            getRowClasses(item, isExpanded) {
                return {
                    'table-row-expanded': isExpanded,
                    'red lighten-5': item.deleted_at
                }
            }
        },

        watch: {
            options: {
                handler(options) {
                    console.log(options);
                    this.$router.replace({
                        query: {
                            ...this.$route.query,
                            page: options.page || 1,
                            per_page: options.itemsPerPage || 100
                        }
                    });
                    this.loadData();
                },
                deep: true,
            },
        },

        computed: {
            headers() {
                return [
                    {text: 'Kundenr.', value: 'customer_number'},
                    {text: 'Navn', value: 'name'},
                    {text: 'Kundetype', value: 'is_company', align: 'center'},
                    {text: 'Telefon', value: 'phone'},
                    {text: 'Epost', value: 'email'},
                    {text: 'Antall biler', value: 'cars_count', align: 'center'},
                    {text: 'Adresse', value: 'zip_code'},
                    {text: `${this.total} kunder funnet`, value: 'id', align: 'center', sortable: false}
                ]
            },

            footerProps() {
                return {
                    'items-per-page-text': 'Kunder per side:',
                    'items-per-page-options': [100, 200, 500, {text: 'Alle', value: -1}]
                }
            },

            options: {
                get() {
                    return tableOptionsFromRoute(this.$route);
                },
                set(obj) {
                    updateRouteFromOptions(this.$router, this.$route, obj);
                }
            },

            total() {
                if (!this.meta) return 0;
                return this.meta.total;
            }

        }
    }
</script>

<style scoped>
    .contact-link {
        text-decoration: none;
    }

    .contact-link .icon {
        padding-right: 0.25rem;
    }

    .table-row-expanded td {
        background-color: #eee;
        font-weight: bold;
    }
</style>
